import React from "react";
import { motion } from "framer-motion";
import { FaGem, FaLink, FaCheckCircle, FaFilm, FaTicketAlt } from "react-icons/fa";
import LiquidGlass from "./LiquidGlass";

const icons = {
  channels: <FaFilm className="text-5xl text-fuchsia-600/60 dark:text-fuchsia-400/60" />,
  links: <FaLink className="text-5xl text-purple-600/60 dark:text-purple-400/60" />,
  tasks: <FaCheckCircle className="text-5xl text-[#0C8BC4]/60 dark:text-[#0C8BC4]/60" />,
  gems: <FaGem className="text-5xl text-amber-600/60 dark:text-amber-400/60" />,
  tickets: <FaTicketAlt className="text-5xl text-red-600/60 dark:text-red-400/60" />,
};

const EmptyState = ({ icon = "tasks", title, subtitle, action }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
    >
      <LiquidGlass className="rounded-2xl p-8 border border-slate-200 dark:border-slate-700/50">
        <div className="flex flex-col items-center text-center space-y-3">
          <motion.div
            animate={{ y: [0, -6, 0] }}
            transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
          >
            {icons[icon] || icons.tasks}
          </motion.div>
          <h3 className="text-lg font-semibold text-slate-800 dark:text-slate-200">
            {title || "Nothing here yet"}
          </h3>
          {subtitle && (
            <p className="text-sm text-slate-500 dark:text-slate-400 max-w-xs">{subtitle}</p>
          )}
          {action && (
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={action.onClick}
              className="mt-2 px-5 py-2 rounded-lg bg-fuchsia-600 hover:bg-fuchsia-700 text-white text-sm font-medium transition-colors"
            >
              {action.label}
            </motion.button>
          )}
        </div>
      </LiquidGlass>
    </motion.div>
  );
};

export default EmptyState;
